import Base from './components/cells/Base';
import Percentage from './components/cells/Percentage';
export default function PercentageCell() {}

PercentageCell.prototype.init = function (params) {
    this.eGui = Base(Percentage(params), params);
    return;
};

PercentageCell.prototype.getGui = function () {
    return this.eGui;
};
